import PropTypes from 'prop-types';
import React from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { CachedImage, ImageView, IMAGE_WIDTH, IMAGE_HEIGHT } from '../../components';
import { getFullscreenImageUrl } from '../../components/attachments/web_fullscreen';

import { COLOR, __WEB__ } from '../../../constants/styles';

import { GROUP_MESSAGE } from '../../../constants/objectTypes';

export { IMAGE_WIDTH, IMAGE_HEIGHT };

export default class MessageImage extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    // maybe should check id here?
    return this.props.currentMessage.image !== nextProps.currentMessage.image;
  }

  showFullScreen = async () => {
    if (__WEB__) {
      const url = await getFullscreenImageUrl(this._attachment);
      if (url) window.open(url, '_blank');
      return;
    }
    this.props.showFullScreenImage?.(this._attachment);
  };

  render() {
    const { currentMessage } = this.props;
    const { messageId, image } = currentMessage;

    const containerStyle = StyleSheet.flatten([
      styles.container,
      styles.groupChatModeContainerStyle,
    ]);

    if (currentMessage.imagePlaceholder) {
      return (
        <View style={containerStyle}>
          <ImageView loading={true} imageUri={currentMessage.previewUri} loadingIndicator={true} />
        </View>
      );
    }

    const objectType = GROUP_MESSAGE;
    this._attachment = attachmentConfig = {
      objectType,
      objectId: messageId,
      fileName: image,
    };

    return (
      <View style={containerStyle}>
        <CachedImage attachment={attachmentConfig} isThumb={true} onPress={this.showFullScreen} />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
  },
  groupChatModeContainerStyle: {},
});

MessageImage.defaultProps = {
  currentMessage: {
    image: null,
  },
};
